<template>
    <fullscreen-drawer
        v-if="featureFlags['live-site-responsive-design']"
        :visible="visible"
        title="Conversion Detail"
        @close="handleClose"
    >
        <payout-details :payout="data" :type="PAYOUT_TYPE_CONVERSION" />
    </fullscreen-drawer>

    <g-drawer v-else :visible="visible" height="100%" get-container="#app" placement="bottom" @close="handleClose">
        <payout-details :payout="data" :type="PAYOUT_TYPE_CONVERSION" />
    </g-drawer>
</template>

<script>
    import PayoutDetails from './PayoutDetails.vue';
    import { PAYOUT_TYPE_CONVERSION } from '../../../../../app-v2/constants/payouts';
    import FullscreenDrawer from "../../../../../app-v2/components/library/FullscreenDrawer";
    import {useFeatureFlagsStore} from "../../../../../stores";

    export default {
        name: 'ConversionDetailsDrawer',

        components: {
            FullscreenDrawer,
            PayoutDetails
        },

        props: {
            visible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: null
            }
        },

        setup(props, context) {
            const featureFlags = useFeatureFlagsStore().data;

            const handleClose = () => {
                context.emit('close');
            };

            return {
                PAYOUT_TYPE_CONVERSION,
                handleClose,
                featureFlags
            };
        }
    };
</script>
